const EventDefinitionPriorityEnum = {
  LOW: 1,
  NORMAL: 2,
  HIGH: 3,
  properties: {
    1: { name: 'low' },
    2: { name: 'normal' },
    3: { name: 'high' },
  },
};

export default EventDefinitionPriorityEnum;
